import { Component, OnInit } from '@angular/core';
import { PopoverController, ToastController, Platform } from '@ionic/angular';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
import {
  NotificationApiService,
  NotificationEventInterface,
} from 'src/app/services/notification-api/notification-api.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { LoginService } from 'src/app/services/login/login.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { AppRateService } from "src/app/services/app-rate/app-rate.service";
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';

@Component({
  selector: 'app-server-notification',
  templateUrl: './server-notification.component.html',
  styleUrls: ['./server-notification.component.scss'],
})
export class ServerNotificationComponent implements OnInit {
  public Que = [];
  public activeNotifications = 0;
  public isGaming: boolean = false;
  private checkNotificationInterval: any;
  constructor(
    private configService: ConfigService,
    private notificationApiService: NotificationApiService,
    private userSession: UserSessionService,
    private accountBalanceService: AccountBalanceService,
    private globalErrorHandlerService: GlobalErrorHandlerService,
    // private jackpotCounter: JackpotCounterProvider,
    private eventsService: EventsService,
    private loginService: LoginService,
    private appRateService: AppRateService,
    private platform: Platform,
    private authenticationService: AuthenticationService,
    private navigator: Navigator,
    private responsibleGamingProvider: ResponsibleGamingService,
    private toastController: ToastController
  ) { }

  ngOnInit() {
    this.subscribeToNotifications();
    this.eventsService.subscribe('event:notifications:start', () => {
      this.checkAvailabilityConditions();
    });

    this.eventsService.subscribe('event:authentication:logout', () => {
      this.Que = [];
      this.activeNotifications = 0;
    });

    this.eventsService.subscribe("event:balanceState", (data) => {
      if(data && ! data.show){
        this.isGaming = true;
      } else {
        this.isGaming = false;
      }
    });

  }

  subscribeToNotifications() {

    this.notificationApiService
      .listen()
      .subscribe((e: NotificationEventInterface) => {
        try {
          this.eventsService.publish('event:geoComply:dismiss');
        } catch (e) { }
        switch (e.type) {
          case 'PUSH_APP_SESSION_STATS':
            this.navigator.openPopover(
              'PopoverSessionStats',
              { message: e },
              'standard-popover session-stats',
              false,
              true,
              true,
              -1,
              'cover',
              true
            );
            this.eventsService.publish('event:sessonstats', e);
            break;
          case 'LOYALTY_NEW_TIER':
            /*page = PopoverFactory('LoyaltyRewardsPopover');
                    popover = this.popoverCtrl.create(page, e, {
                        showBackdrop: false,
                        cssClass: 'standard-popover loyaltytier'
                    });
                    popover.present();*/
            break;
          case 'MILESTONE_AWARD':
            /*page = PopoverFactory('LoyaltyPopover');
                    popover = this.popoverCtrl.create(page, e, {
                        showBackdrop: false,
                        cssClass: 'standard-popover levelup'
                    });
                    popover.present();*/
            break;
          case 'LOYALTY_TIER_WILL_EXPIRY':
            break;
          case 'MARKETING_OFFER':
            this.addNotificationToQue(e);
            break;
          case 'MARKETING_MESSAGE':
            this.addNotificationToQue(e);
            break;
          case 'IDSCAN_IDENTIFICATION_CALLBACK':
            this.sendIDNowResposne(e);
            break;
          case 'RESERVED_BIG_WIN':
            /*page = PopoverFactory('NotificationsPopoverPage');
                    popover = this.popoverCtrl.create(page, e, {
                        showBackdrop: false,
                        cssClass: 'standard-popover levelup'
                    });
                    popover.present();*/
            break;
          case 'MARKETING_PROMO':
            break;
          case 'BAGDE_AWARDED':
            break;
          case 'BALANCE':
            this.accountBalanceService.updateBalanceFromNotification(e);
            this.sendGameStatsResponse(e);
            break;
          case 'LOGOUT':
            this.userSession.isAuthenticated().then(isAuthenticated => {
              if (isAuthenticated) {
                this.globalErrorHandlerService.handleError({
                  code: 'INVALID_SESSION_TOKEN',
                });
                //Added one more call for logout which will always kick in. Running same domain in new browser/multiple device case.
                this.eventsService.publish('logout:refresh');
              } else {
                //Do not publish multiple event on logout which leads to duplicate logout call
                //and creates issue to reload the site when user switch the location for NJ/PA
                //this.eventsService.publish('logout:refresh');
                console.log('already unauthenticated');
              }
            });
            this.eventsService.publish("event:tracker:logout");
            break;
          case 'PREVIOUS_DISCONNECTION':
            this.userSession.isAuthenticated().then(isAuthenticated => {
              if (isAuthenticated) {
                if ('customField2' in e) {
                  let disconnectionTimeframe = e['customField2'];
                  let disconnectionTimeframeAllowed =
                    this.configService.getConfig().DISCONNECT_TIME_ALLOWED ||
                    5000;

                  if (
                    ~~disconnectionTimeframe > ~~disconnectionTimeframeAllowed
                  ) {
                    this.globalErrorHandlerService.handleError({
                      code: 'INVALID_DISCONNECT_TIME_ALLOWED',
                    });
                  }
                }
              } else {
                this.eventsService.publish('logout:refresh');
                console.log('already unauthenticated');
              }
            });
            break;
          case 'JACKPOT':
            let gameTypeId = e.parametersMap ? e.parametersMap.gameTypeIds : '';
            let currency = e.parametersMap ? e.parametersMap.currency : '';
            let jackpotID = e.customField3 ? e.customField3 : '';
            let siteJackpotID =
              this.configService.getConfig().FEATURE_JACKPOT_ID;

            if (jackpotID == siteJackpotID && gameTypeId === '333') {
              if (currency == this.configService.getConfig().DEFAULT_CURRENCY) {
                let data: any = {
                  amount: e.parametersMap.amount,
                  currency: currency,
                };
                //this.jackpotCounter.sendCounterValue(data);
              }
            }
            break;
          case 'JACKPOT_HIT':
            // skip for current player
            /*let customerId    = e.parametersMap ? e.parametersMap.winner : '';
                    this.userSession.getCustomer().subscribe((customer) => {
                        if (e.customField4 == this.configService.getConfig().DEFAULT_CURRENCY && customer && customer.customerId.toString() != customerId) {
                            let jackpotText = e.text;
                            let toast = this.toastCtrl.create({
                                message: jackpotText,
                                duration: 8000,
                                position: 'bottom'
                            });
                            toast.present();
                        }
                    });*/
            break;
          case 'APPROVED_DEPOSIT':
            this.pushPlayerDepositSuccess(e);
            break;
          case 'FAILED_DEPOSIT':
            this.presentToast("Your deposit transaction did not succeed. You can contact support for help.");
            this.eventsService.publish('event:deposit:failed', e);
            break;
          case 'PLAYER_CONVERSION':
            this.pushPlayerConversionEvent(e);
            break;
          case 'PLAYER_BET':
            this.pushPlayerBetEvent(e);
            break;
          case 'REGISTRATION_COMPLETE':
            this.pushPlayerRegistrationComplete();
            this.annualReconfirmationReKycCheck();
            break;
          case 'APP_RATING_ALERT':
            this.addNotificationToQue(e);
            break;
          case 'PUSH_GAME_SESSION_STATS':
            console.log('netWin : ' + e.parametersMap.netWinAmount);
            this.sendGameNetWinData(e);
            break;
          case 'REAFFIRM_LIMIT_CHANGE':
            console.log('REAFFIRM_LIMIT_CHANGE received');
            this.reaffirmLimitChange();
            break;
          case 'ALERT':
            if (this.Que.length) {
              return this.navigator.openPopover('PopoverAlertComponent', {
                content: e.text,
                title: e.title,
                htmlText: e.htmlText,
                notificationImage: e.notificationImage,
                notificationLink: e.notificationLink,
                timeout: 30000,
              });
             
            }else {
              this.addNotificationToQue(e);
            }
            break;       
          case 'MESSAGE':
            if (this.Que.length) {
              return this.navigator.openPopover('PopoverAlertComponent', {
                content: e.text,
                title: e.title,
                htmlText: e.htmlText,
                notificationImage: e.notificationImage,
                notificationLink: e.notificationLink,
                timeout: 30000,
              });
             
            }else {
              this.addNotificationToQue(e);
            }
            break;
          case 'MANUAL':
          default:
            console.log('---Client is not handling this notification---', e.type)
            /*const popoverComp = 'PopoverAlertComponent';
            const data: any = {
              content: e.text,
              title: e.title,
              timeout: 30000,
            };

            return this.navigator.openPopover(popoverComp, data);*/
            /*let alert_page = PopoverFactory('NotificationsPopoverPage');
                    break;
                case 'APPROVED_DEPOSIT':
                    this.eventsService.publish('event:deposit:approved');
                    break;
                case 'FAILED_DEPOSIT':
                    this.eventsService.publish('event:deposit:failed', e);
                    break;
                case 'IOS_RATING_ALERT':
                    this.eventsService.publish('event:load:apprate');
                    break;
                case 'IDSCAN_IDENTIFICATION_CALLBACK':
                    this.sendIDNowResposne(e);
                    break;
                case 'PUSH_GAME_SESSION_STATS':
                    console.log('netWin : ' + e.parametersMap.netWinAmount);
                    this.sendGameStatsResponse(e);
                    break;
                case 'ALERT':
                case 'MESSAGE':
                case 'MANUAL':
                default:
                    /*let alert_page = PopoverFactory('NotificationsPopoverPage');
                    let alert_popover = this.popoverCtrl.create(alert_page, e, {
                        showBackdrop: false,
                        enableBackdropDismiss: true,
                        cssClass: 'custom-popover'
                    });
                    alert_popover.present();*/
            break;
        }
      });
  }

  checkAvailabilityConditions(){
     this.checkNotificationInterval = this.configService.getConfig().FEATURE_CHECK_NOTIFICATION_INTERVAL || 5000;
     setTimeout(() => this.checkAvailabilityConditions(), this.checkNotificationInterval);
     if(!(this.isGaming || this.navigator.activeModals.length > 0 || this.navigator.activePopovers.length > 0  || !this.navigator.isOnLobby() || this.activeNotifications ==1)){
         this.showNotifications();
     }
  }

  addNotificationToQue(e: NotificationEventInterface) {
    this.Que.push(e);
  }

  showNotifications() {
    if (this.Que.length) {
      let e = this.Que[0];
      this.Que.shift();
      if(e && e.type == "APP_RATING_ALERT"){
        this.showAppRateNotification(e);
      }else if(e.type == 'ALERT' || e.type == 'MESSAGE'){
        return this.navigator.openPopover('PopoverAlertComponent', {
          content: e.text,
          title: e.title,
          htmlText: e.htmlText,
          notificationImage: e.notificationImage,
          notificationLink: e.notificationLink,
          timeout: 30000,
          onCloseFunc: this.nextNotification
      });
      
      } else {
        this.showNotification(e);
      }
    }
  }

  showAppRateNotification(e) {
    if(this.platform.is("capacitor")){
      this.activeNotifications = 1;
      if(this.platform.is("ios")){
        e.onCloseFunc = this.nextNotification;
        this.appRateService.processAppRate(e);
      } else if(this.platform.is("android")){
        this.appRateService.processAppRate(e);
        this.nextNotification('closeButton');
      }
    }
  }

  showNotification(e) {
    e.onCloseFunc = this.nextNotification;
    this.navigator.openPopover(
      'PopoverMarketingComponent',
      e,
      'standard-popover marketing-notification',
      true,
      true,
      true
    );

    this.activeNotifications = 1;
  }

  nextNotification = (emmiter = null) => {
    this.activeNotifications = 0;
    if (emmiter === 'closeButton') {
      this.showNotifications();
    }
  };

  sendGameStatsResponse(e) {
    const previousBalance = this.accountBalanceService.startingBalance;
    const currentBalance = e.parametersMap.amount;
    let netWinAmount: any = currentBalance - previousBalance;
    netWinAmount = String(netWinAmount.toFixed(2));
    //This looks not proper fix for STRDST-473..as below event is purely used for NetWin information
    //this.eventsService.publish('event:GameStats:Response', netWinAmount);
  }

  sendIDNowResposne(e) {
    console.log('ID NOW Response');
    console.log(e.customField2);
    this.eventsService.publish('event:IDNow:CallBack', e.customField2)
  }

  annualReconfirmationReKycCheck(){
    this.eventsService.publish('event:ReKyc:AnnualReconfirmation');
  }

  sendGameNetWinData(e) {
    console.log('Game Stats Response ' + e.type);
    console.log('--Game Stats netWinAmount--', e.parametersMap.netWinAmount);
    this.eventsService.publish('event:GameStats:Response', e.parametersMap.netWinAmount);
  }

  pushPlayerDepositSuccess(event){
    let data;
    let hasMap: boolean = false;

    if("parametersMap" in event) {
        data = event.parametersMap;
        hasMap = true;
    }

    const depositEventData: AffiliateTrackerCallbackParams = {
        customer_id: this.userSession.getCustomerId() ? this.userSession.getCustomerId() : "",
        amount: (hasMap &&  "amount" in data) ? data.amount : "" ,
        paymentMethod: (hasMap &&  "payment_type_code" in data) ? data.payment_type_code : "" ,
        transaction_id: (hasMap &&  "id" in data) ? data.id : "" ,
    }
    console.log('Deposit Approved', depositEventData);
    setTimeout(() => {
      this.presentToast("Your deposit was approved!");
      this.eventsService.publish('event:deposit', depositEventData )
    }, 150);
}

pushPlayerConversionEvent(event) {
  let conversionEventData: AffiliateTrackerCallbackParams = {
      customer_id: this.loginService.getCustomerID(),
      registration_complete: "1",
      deposit: "1",
      bet_placed: "1"
  }
  setTimeout(() => this.eventsService.publish('event:conversion:set', conversionEventData ), 2000);
}

pushPlayerBetEvent(event) {
  let data;
  let hasMap: boolean = false;
  if("parametersMap" in event) {
      data = event.parametersMap;
      hasMap = true;
  }
  let betEventData: AffiliateTrackerCallbackParams = {
      customer_id: this.loginService.getCustomerID(),
      "game_provider": (hasMap &&  "game_provider" in data) ? data.game_provider : "" ,
      "restricted_amount": (hasMap &&  "restricted_amount" in data) ? data.restricted_amount : "" ,
      "wager_amount": (hasMap &&  "wager_amount" in data) ? data.wager_amount : "" ,
      "wager_trx_id": (hasMap &&  "wager_trx_id" in data) ? data.wager_trx_id : "" ,
      "deposit_count": (hasMap &&  "deposit_count" in data) ? data.deposit_count : "" ,
      "withdrawal_count": (hasMap &&  "withdrawal_count" in data) ? data.withdrawal_count : "" ,
      "total_deposit":(hasMap &&  "total_deposit" in data) ? data.total_deposit : "" ,
      "total_withdrawal": (hasMap &&  "total_withdrawal" in data) ? data.total_withdrawal : "" ,
      "game_name": (hasMap &&  "game_name" in data) ? data.game_name : "" ,
  }
  setTimeout(
      () => this.eventsService.publish('event:bet:server', betEventData ), 1000);
}

pushPlayerRegistrationComplete(){
  let registrationData: AffiliateTrackerCallbackParams = {
    customer_id: this.authenticationService.customer.customerId
  }

  setTimeout(
    () => this.eventsService.publish('event:signupcomplete', registrationData ), 1000);
}

async presentToast(toast_message) {
  const toast = await this.toastController.create({
    message: toast_message,
    position: 'top',
    duration: 10000,
    cssClass: "test",
    color: "secondary",
    buttons: [
      {
        text: 'Close',
        role: 'close'
      }
    ]
  });

  await toast.present();
  const { role } = await toast.onDidDismiss();

}

reaffirmLimitChange(){
  this.responsibleGamingProvider.getAllPendingLimit().subscribe(
    (response: any) => {
      if (response && !!response.result && !!response.payload) {
        if (response.payload.length !== 0) {
          this.navigator.navigateTo('LimitConfirmationComponent', { forceModal: true });
        } else {
          console.log('No Pending Limit for User')
        }
      }
    },
    (error) => {
      console.log('ERROR: No Pending Limit for User')
      //console.log(error);
    }
  );
}

}
